import { useEffect, useState, startTransition } from "react";
import { api } from "@/lib/api";
import { islandUrl } from "@/lib/translations";

let cache = null;
let loading = null;
const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!loading) loading = api.get("/places").then((r) => (cache = r.data)).catch(() => (cache = []));
  return loading;
};
/** Alle Online-Ortsseiten (einmal geladen, seitenweit gecacht). */
export const usePlaces = () => {
  const [p, setP] = useState(cache || []);
  useEffect(() => { load().then((d) => startTransition(() => setP(d))); }, []);
  return p;
};
/** Ortsseite zu einem Objekt: gleiche Insel, Ortsname (bzw. „match“) im Standort enthalten – wie place_properties im Backend. */
export const placeFor = (places, property) => {
  const loc = (property.location || "").toLowerCase();
  if (!loc) return null;
  return places.find((pl) => pl.island === property.island && loc.includes((pl.match || pl.name).toLowerCase())) || null;
};
export const placeUrl = (pl, lang) => `${islandUrl(pl.island, lang)}/${pl.slug}`;

let regionCache = null, regionLoading = null;
export const loadRegions = () => {
  if (regionCache) return Promise.resolve(regionCache);
  if (!regionLoading) regionLoading = api.get("/regions").then((r) => (regionCache = r.data)).catch(() => (regionCache = []));
  return regionLoading;
};
/** Alle Regionen (einmal geladen, seitenweit gecacht). */
export const useRegions = () => {
  const [r, setR] = useState(regionCache || []);
  useEffect(() => { loadRegions().then((d) => startTransition(() => setR(d))); }, []);
  return r;
};
export const regionFor = (regions, property) => (property.region ? regions.find((r) => r.island === property.island && r.slug === property.region) || null : null);
export const regionUrl = (rg, lang) => `${islandUrl(rg.island, lang)}/${rg.slug}`;
